import { useCallback } from 'react';

import { Popconfirm, Space } from 'antd';
import { CloseIcon } from '../../../Icons';
import { WhiteButton } from '../../../Button';

// Utils
import { useTranslation } from 'react-i18next';

// Redux
import { uiActions } from '../../../../store/slices/ui';
import { loginToSpotify } from '../../../../store/slices/auth';
import { useAppDispatch, useAppSelector } from '../../../../store/store';

const LoginButton = () => {
  const { t } = useTranslation(['home']);
  const dispatch = useAppDispatch();
  const tooltipOpen = useAppSelector((state) => state.ui.loginButtonOpen);

  const onClose = useCallback(() => {
    dispatch(uiActions.closeLoginButton());
  }, [dispatch]);

  return (
    <Popconfirm
      icon={null}
      open={tooltipOpen}
      onCancel={onClose}
      placement='bottomLeft'
      rootClassName='login-tooltip'
      cancelText={<CloseIcon />}
      title={t('You’re logged out')}
      cancelButtonProps={{ type: 'text' }}
      okButtonProps={{ className: 'white-button small' }}
      description={t('Log in to add this to your Liked Songs.')}
    >
      <WhiteButton title={t('Log In')} onClick={() => dispatch(loginToSpotify())} />
    </Popconfirm>
  );
};

const Header = ({ opacity }: { opacity: number; title?: string }) => {
  const user = useAppSelector(
    (state) => state.auth.user,
    (prev, next) => prev?.id === next?.id
  );

  return (
    <div
      className={`flex r-0 flex-row items-center bg-gray-900 rounded-t-md z-10`}
      style={{ backgroundColor: `rgba(12, 12, 12, ${opacity}%)` }}
    >
      <div className='flex flex-row items-center'>
        <Space>


          {/*
          <div className='news'>
            <News />
          </div> */}

          {!user && <LoginButton />}
        </Space>
      </div>
    </div>
  );
};

export default Header;
